import { PLAYER_CREATE, PLAYER_EDIT_NAME } from '../actionTypes';

export const initialState = {
  byId: {},
  allIds: []
};

export default function(state = initialState, action) {
  if (action.payload) var { id, name } = action.payload;
  switch (action.type) {
    case PLAYER_CREATE:
      return {
        // ...state, unsure
        byId: {
          ...state.byId,
          [id]: {
            id,
            name
          }
        },
        allIds: [...state.allIds, id]
      };
    case PLAYER_EDIT_NAME:
      // const { id, value } = action.payload;
      const temp = [...state.allIds];
      if (state.allIds.indexOf(id) === -1) {
        temp.push(id);
      }
      return {
        byId: {
          ...state.byId,
          [id]: {
            id,
            name
          }
        },
        allIds: temp,
      };
    default:
      return state;
  }
}
